import { useContext } from 'react';

import ModuleContext from '../../../../_contexts/ModuleContext';
import SharedMaterialsContext from '../../../_contexts/SharedMaterialsContext';
import { SlideSet } from '../../../../../../api/slide-set';
import useSlideSets from '../../../../hooks/useSlideSets';

export default function useSlideSetApps(options?: { optional?: boolean }) {
  const { module } = useContext(ModuleContext);
  const { sharedMaterials } = useContext(SharedMaterialsContext);
  const { slideSets } = useSlideSets(options);

  if (!module?.enableSlideSetsAccess) {
    return { slideSets: [] };
  }

  const sharedSlideSets = (sharedMaterials ?? []).filter(
    material => material.materialType === 'slide-set',
  ) as SlideSet[];

  const sortedSlideSets = [...slideSets, ...sharedSlideSets].sort(
    (a, b) => Number(Boolean(a.userId)) - Number(Boolean(b.userId)),
  );

  return { slideSets: sortedSlideSets };
}
